@if (hasResult === false) {
  <app-advisor-errorpage></app-advisor-errorpage>
}
@if (hasResult === true) {
  <div class="grid-container" #resultWrapper>
    <div class="grid-x grid-margin-x grid-margin-y headline-wrapper">
      <div class="cell small-12 large-offset-1 large-10">
        <h1 class="text-center" [innerHTML]="textkeyPrefix + '.headline' | translate"></h1>
      </div>
      <div class="cell small-12 large-offset-1 large-10">
        <h2 [innerHTML]="textkeyPrefix + '.headline.einordnung' |translate"></h2>
        <canvas baseChart #compareChart='base-chart' [data]="compareChartData" [options]="compareChartOptions"> </canvas>
        <p class="callout" [ngClass]="{warning: anfrage.result.rating_measurement === 'very_low' || anfrage.result.rating_measurement === 'very_high'}"
        [innerHTML]="textkeyPrefix + '.einschaetzung_durchschnitt.' + anfrage.result.rating_measurement | translate: {percent: anfrage.result.proportion.net_household}"></p>
        @if (anfrage.userInput.exist_pv === 'ja') {
          <p class="callout"
          [innerHTML]="textkeyPrefix + '.pv_eigenstrom' | translate: {kwh: anfrage.result.self.pv, percent: anfrage.result.proportion.pv }"></p>
        }
        <div class="callout" [ngClass]="{warning: anfrage.result.rating_calculation === 'very_high'}">
          <p [innerHTML]="textkeyPrefix + '.einschaetzung_berechnung.' + anfrage.result.rating_calculation | translate"></p>
          @if (anfrage.userInput.exist_hp === 'ja' && anfrage.userInput.exist_wel_wp !== 'ja') {
            <p [innerHTML]="textkeyPrefix + '.hinweis.waermepumpe' | translate"
            ></p>
          }
          @if (anfrage.userInput.exist_eheat === 'ja' && anfrage.userInput.exist_wel_eheat !== 'ja') {
            <p [innerHTML]="textkeyPrefix + '.hinweis.stromdirektheizung' | translate"
            ></p>
          }
          @if (anfrage.result.warmwater > 0) {
            <p [innerHTML]="textkeyPrefix + '.hinweis.warmwasser' | translate"
            ></p>
          }
        </div>
      </div>
      <div class="cell small-12 large-offset-1 large-10">
        <h2 [innerHTML]="textkeyPrefix + '.headline.zusammensetzung' | translate"></h2>
        <p [innerHTML]="textkeyPrefix + '.text.zusammensetzung' | translate"></p>
        <canvas baseChart #categoriesChart='base-chart' [data]="categoriesChartData" [options]="categoriesChartOptions"> </canvas>
      </div>
      <div class="cell small-12 large-offset-1 large-10">
        <mat-accordion multi="">
          <mat-expansion-panel [expanded]="true">
            @if (anfrage.result.proportion.ws > 0) {
              <mat-expansion-panel-header class="category-no-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.waschen_mehr' | translate: {percent: anfrage.result.proportion.ws}">
              </mat-expansion-panel-header>
            }
            @if (anfrage.result.proportion.ws <= 0) {
              <mat-expansion-panel-header class="category-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.waschen_weniger' | translate: {percent: anfrage.result.proportion.ws * -1}">
              </mat-expansion-panel-header>
            }
            <p [innerHTML]="textkeyPrefix + '.kategorie.erklaerung.waschen' | translate"></p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            @if (anfrage.result.proportion.kg > 0) {
              <mat-expansion-panel-header class="category-no-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.kuehlen_mehr' | translate: {percent: anfrage.result.proportion.kg}">
              </mat-expansion-panel-header>
            }
            @if (anfrage.result.proportion.kg <= 0) {
              <mat-expansion-panel-header class="category-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.kuehlen_weniger' | translate: {percent: anfrage.result.proportion.kg * -1}">
              </mat-expansion-panel-header>
            }
            <p [innerHTML]="textkeyPrefix + '.kategorie.erklaerung.kuehlen' | translate"></p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            @if (anfrage.result.proportion.kb > 0) {
              <mat-expansion-panel-header class="category-no-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.kochen_mehr' | translate: {percent: anfrage.result.proportion.kb}">
              </mat-expansion-panel-header>
            }
            @if (anfrage.result.proportion.kb <= 0) {
              <mat-expansion-panel-header class="category-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.kochen_weniger' | translate: {percent: anfrage.result.proportion.kb * -1}">
              </mat-expansion-panel-header>
            }
            <p [innerHTML]="textkeyPrefix + '.kategorie.erklaerung.kochen' | translate"></p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            @if (anfrage.result.proportion.ue > 0) {
              <mat-expansion-panel-header class="category-no-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.unterhaltung_mehr' | translate: {percent: anfrage.result.proportion.ue}">
              </mat-expansion-panel-header>
            }
            @if (anfrage.result.proportion.ue <= 0) {
              <mat-expansion-panel-header class="category-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.unterhaltung_weniger' | translate: {percent: anfrage.result.proportion.ue * -1}">
              </mat-expansion-panel-header>
            }
            <p [innerHTML]="textkeyPrefix + '.kategorie.erklaerung.unterhaltung' | translate"></p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            @if (anfrage.result.proportion.lighting > 0) {
              <mat-expansion-panel-header class="category-no-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.beleuchtung_mehr' | translate: {percent: anfrage.result.proportion.lighting}">
              </mat-expansion-panel-header>
            }
            @if (anfrage.result.proportion.lighting <= 0) {
              <mat-expansion-panel-header class="category-savings"
                [innerHTML]="textkeyPrefix + '.kategorie.headline.beleuchtung_weniger' | translate: {percent: anfrage.result.proportion.lighting * -1}">
              </mat-expansion-panel-header>
            }
            <p [innerHTML]="textkeyPrefix + '.kategorie.erklaerung.beleuchtung' | translate"></p>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header [innerHTML]="textkeyPrefix + '.kategorie.headline.sonstiges' | translate"></mat-expansion-panel-header>
            <p [innerHTML]="textkeyPrefix + '.kategorie.erklaerung.sonstiges' | translate"></p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
}


@if (hasResult === true) {
  <div class="grid-x grid-padding-x grid-margin-y">
    <div class="cell">
      <app-step-buttons previousLink="../../ausstattung-haushalt/unterhaltungselektronik/10"
        mediumWidthRight="10" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="10"
      previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
    </div>
  </div>
}
